// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/src/models/filterState';
import model_2 from '/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/src/models/global';
import model_3 from '/Users/caocuong.tran/Desktop/SEA/GRN/GRN.AOV-planing-react/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'filterState', model: model_1 },
model_2: { namespace: 'global', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
